export const authMeta = {
  customer: 'CreditSelectionFrontend',
  productName: 'Подбор кредита',
};
